module.exports = __webpack_public_path__ + "static/media/javea-25.ed507b19.jpg";